import { getAxiosInstance } from '../client';
/** Mutation functions for calls domain */
export const callsMutations = {
    /** PATCH /calls/:id - Update call */
    update: (callId, dto) => getAxiosInstance()
        .patch(`/calls/${callId}`, dto)
        .then((r) => r.data),
    /** POST /calls/:id/cancel - Cancel call */
    cancel: (callId) => getAxiosInstance()
        .post(`/calls/${callId}/cancel`)
        .then((r) => r.data),
    /** POST /calls/:id/init - Initialize call (set initializationTime) */
    init: (callId) => getAxiosInstance()
        .post(`/calls/${callId}/init`)
        .then((r) => r.data),
};
/** Mutation functions for call patients */
export const callPatientMutations = {
    /** PATCH /call-patients/:id - Update call patient */
    update: (callPatientId, dto) => getAxiosInstance()
        .patch(`/call-patients/${callPatientId}`, dto)
        .then((r) => r.data),
};
//# sourceMappingURL=calls.mutations.js.map